import { fontSizeRemDivision } from "../../consts/FontSizeRemDivision.const";

export function convertPixelToRem(pixelValue: number): number {
    return pixelValue / fontSizeRemDivision;
}
